import { BaseError } from '@webapp/core/utils/errors/BaseError'

type ERRORS = 'SEARCH_FAILED' | 'SEARCH_FAILED_WITH_MESSAGE'

export class GlobalSearchUseCaseErrors extends BaseError<ERRORS> {}
